// src/components/QuickNoteModal.js
import React, { useRef, useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import NoteEditor from "./NoteEditor";
import { useNotes } from "../services/NotesContext";
import { COLOR_CATEGORIES } from "../constants/colorCategories";
import { useTranslation } from 'react-i18next';
import "../css/Note.css";

import { useAuth } from '../services/AuthContext';

const QuickNoteModal = ({
  show,
  onClose,
  onSave,
  presetCategory,
  scanResultId,
  existingNote,
}) => {
  const { t } = useTranslation();
  const textareaRef = useRef(null);
  const { refreshNotesHash } = useNotes();
  const [title, setTitle] = useState(existingNote?.title || "");
  const { userKey } = useAuth(); // eslint-disable-line no-unused-vars
  const { saveNote } = useNotes();

  useEffect(() => {
      setTitle(existingNote?.title || "");
    }, [existingNote]);


  if (!show) return null;

  const initialColor =
    typeof presetCategory === "number"
      ? COLOR_CATEGORIES[presetCategory] || COLOR_CATEGORIES[0]
      : COLOR_CATEGORIES.find((c) => c.id === presetCategory) ||
        COLOR_CATEGORIES[0];

  const handleSaveNote = async (noteData) => {
    try {
      const note = await saveNote({
        _id: existingNote?._id,
        title,
        text: noteData.text,
        categoryId: noteData.categoryId,
        scanResultId,
      });
     
      await refreshNotesHash();

      onSave?.(note); // on transmet la note sauvegardée au parent
      onClose();
    } catch (err) {
      console.error("Erreur lors de la sauvegarde :", err);
      alert(err.message);
    }
  };

  const handleClose = () => {
    setTitle(""); // on vide le titre
    onClose?.();  // on appelle le onClose du parent
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      onEntered={() => textareaRef.current?.focus()}
    >
      <Modal.Header>
        {/* 🔹 Champ titre éditable moderne */}
        <input
          type="text"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          placeholder={t(`note.input.title`)}
          style={{
            flex: 1,
            background: "none",
            border: "none",
            outline: "none",
            color: "#f5f5f5",
            fontSize: "1.2rem",
            fontWeight: "600",
            padding: "0.2rem 0.4rem",
            borderBottom: "1px solid #555",
            transition: "border-color 0.2s ease",
          }}
          onFocus={(e) => (e.target.style.borderColor = "#6F3F89")}
          onBlur={(e) => (e.target.style.borderColor = "#555")}
        />
      </Modal.Header>

      <Modal.Body className="modal-add-note">
        <NoteEditor
          textareaRef={textareaRef}
          initialColor={initialColor}
          colorOptions={COLOR_CATEGORIES}
          showCategory={true}
          existingNote={existingNote}
          onSave={handleSaveNote}
          onCancel={handleClose}
        />
      </Modal.Body>
    </Modal>
  );
};

export default QuickNoteModal;
